module.exports = __webpack_public_path__ + "img/music_007.5f3f3133.png";